import { ReactElement, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import About from './About'
import Benefits from './Benefits'
import Clinic from './Clinic'
import FaqContact from './FaqContact'
import HowItWorks from './HowItWorks'
import Intro from './Intro'

export default function Home (): ReactElement {
  const { hash } = useLocation()

  useLayoutEffect(() => {
    const element = document.getElementById(hash.substring(1))
    if (element !== null) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, [hash])

  return <main>
    <Intro />

    <Benefits />

    <HowItWorks />

    <About />

    <Clinic />

    <FaqContact />
  </main>
}
